import { LangContryCode } from './../model/lang-contry-code.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contryCodeFlag',
})
export class ContryCodeFlagPipe implements PipeTransform {
  code: string = '';

  /**
   * get the country name and return the country flag code
   * @param value string
   * @param args
   * @returns contryCodeFlag as a string
   */
  transform(value: string, ..._args: unknown[]): unknown {
    switch (value?.toLowerCase()) {
      case 'englisch':
      case 'english (uk)': {
        this.code = 'flag flag-' + LangContryCode.englisch;
        return this.code;
      }

      case 'french': {
        this.code = 'flag flag-' + LangContryCode.french;
        return this.code;
      }

      case 'italian': {
        this.code = 'flag flag-' + LangContryCode.italian;
        return this.code;
      }

      case 'japanese': {
        this.code = 'flag flag-' + LangContryCode.japanese;
        return this.code;
      }

      case 'polish': {
        this.code = 'flag flag-' + LangContryCode.polish;
        return this.code;
      }

      case 'german': {
        this.code = 'flag flag-' + LangContryCode.german;
        return this.code;
      }

      case 'irish': {
        this.code = 'flag flag-' + LangContryCode.irisch;
        return this.code;
      }

      case 'chinese (simplified)':
      case 'chinese (traditional)': {
        this.code = 'flag flag-' + LangContryCode.chinese;
        return this.code;
      }

      case 'portuguese (portugal)': {
        this.code = 'flag flag-' + LangContryCode.portugal;
        return this.code;
      }

      case 'portuguese (brazil)': {
        this.code = 'flag flag-' + LangContryCode.brazil;
        return this.code;
      }

      case 'korean': {
        this.code = 'flag flag-' + LangContryCode.korean;
        return this.code;
      }

      case 'spanish': {
        this.code = 'flag flag-' + LangContryCode.spanish;
        return this.code;
      }

      case 'dutch (netherlands)': {
        this.code = 'flag flag-' + LangContryCode.dutch;
        return this.code;
      }

      case 'dutch (belgium) / flemish': {
        this.code = 'flag flag-' + LangContryCode.belgium;
        return this.code;
      }

      case 'romanian': {
        this.code = 'flag flag-' + LangContryCode.romanian;
        return this.code;
      }

      case 'english (us)': {
        this.code = 'flag flag-' + LangContryCode.usa;
        return this.code;
      }

      case 'french (switzerland)':
      case 'italian (swiss)': {
        this.code = 'flag flag-' + LangContryCode.switzerland;
        return this.code;
      }

      case 'danish': {
        this.code = 'flag flag-' + LangContryCode.danish;
        return this.code;
      }

      case 'russian': {
        this.code = 'flag flag-' + LangContryCode.russian;
        return this.code;
      }

      case 'finnish': {
        this.code = 'flag flag-' + LangContryCode.finnish;
        return this.code;
      }

      case 'czech': {
        this.code = 'flag flag-' + LangContryCode.czech;
        return this.code;
      }

      case 'hungarian': {
        this.code = 'flag flag-' + LangContryCode.hungarian;
        return this.code;
      }

      case 'greek': {
        this.code = 'flag flag-' + LangContryCode.greek;
        return this.code;
      }

      case 'latvian': {
        this.code = 'flag flag-' + LangContryCode.latvian;
        return this.code;
      }

      case 'serbian (lateinisch)':
      case 'serbian (kyrillisch)': {
        this.code = 'flag flag-' + LangContryCode.serbian;
        return this.code;
      }

      case 'turkish': {
        this.code = 'flag flag-' + LangContryCode.turkish;
        return this.code;
      }

      case 'tagalog': {
        this.code = 'flag flag-' + LangContryCode.tagalog;
        return this.code;
      }

      case 'arabic': {
        this.code = 'flag flag-' + LangContryCode.arabic;
        return this.code;
      }

      case 'estonian': {
        this.code = 'flag flag-' + LangContryCode.estonian;
        return this.code;
      }

      case 'bulgarian': {
        this.code = 'flag flag-' + LangContryCode.bulgarian;
        return this.code;
      }

      case 'bosnian': {
        this.code = 'flag flag-' + LangContryCode.bosnian;
        return this.code;
      }

      case 'aserbaidschanisch': {
        this.code = 'flag flag-' + LangContryCode.aserbaidschanisch;
        return this.code;
      }

      case 'norwegian': {
        this.code = 'flag flag-' + LangContryCode.norwegian;
        return this.code;
      }

      case 'luxembourgian': {
        this.code = 'flag flag-' + LangContryCode.luxembourgian;
        return this.code;
      }

      case 'albanian': {
        this.code = 'flag flag-' + LangContryCode.albanian;
        return this.code;
      }

      case 'afrikaans': {
        this.code = 'flag flag-' + LangContryCode.afrikaans;
        return this.code;
      }

      case 'hindi': {
        this.code = 'flag flag-' + LangContryCode.hindi;
        return this.code;
      }

      case 'vietnamese': {
        this.code = 'flag flag-' + LangContryCode.vietnamese;
        return this.code;
      }

      case 'zulu': {
        this.code = 'flag flag-' + LangContryCode.zulu;
        return this.code;
      }

      case 'slovak': {
        this.code = 'flag flag-' + LangContryCode.slovak;
        return this.code;
      }

      case 'lithuanian': {
        this.code = 'flag flag-' + LangContryCode.lithuanian;
        return this.code;
      }

      case 'thai': {
        this.code = 'flag flag-' + LangContryCode.thai;
        return this.code;
      }

      case 'georgian': {
        this.code = 'flag flag-' + LangContryCode.georgian;
        return this.code;
      }

      case 'urdu': {
        this.code = 'flag flag-' + LangContryCode.urdu;
        return this.code;
      }

      case 'hebrew': {
        this.code = 'flag flag-' + LangContryCode.hebrew;
        return this.code;
      }

      case 'indonesian': {
        this.code = 'flag flag-' + LangContryCode.indonesian;
        return this.code;
      }

      case 'catalan': {
        this.code = 'flag flag-' + LangContryCode.catalan;
        return this.code;
      }
      // Anzupassen
      case 'uzbek (lat.)': {
        this.code = 'flag flag-' + LangContryCode.uzbeklat;
        return this.code;
      }

      case 'tigrinya': {
        this.code = 'flag flag-' + LangContryCode.tigrinya;
        return this.code;
      }
      case 'taiwanese': {
        this.code = 'flag flag-' + LangContryCode.taiwanese;
        return this.code;
      }
      case 'slovenian': {
        this.code = 'flag flag-' + LangContryCode.slovenia;
        return this.code;
      }
      case 'swedish': {
        this.code = 'flag flag-' + LangContryCode.swedish;
        return this.code;
      }
      case 'persian': {
        this.code = 'flag flag-' + LangContryCode.persian;
        return this.code;
      }
      case 'montenegrin': {
        this.code = 'flag flag-' + LangContryCode.montenegrin;
        return this.code;
      }
      case 'meta-deutsch': {
        this.code = 'flag flag-' + LangContryCode.metaDeutsch;
        return this.code;
      }
      case 'macedonian': {
        this.code = 'flag flag-' + LangContryCode.macedonian;
        return this.code;
      }
      case 'maltese': {
        this.code = 'flag flag-' + LangContryCode.maltese;
        return this.code;
      }
      case 'malayalam': {
        this.code = 'flag flag-' + LangContryCode.malayalam;
        return this.code;
      }
      case 'malay': {
        this.code = 'flag flag-' + LangContryCode.malay;
        return this.code;
      }
      case 'kurdish': {
        this.code = 'flag flag-' + LangContryCode.kurdish;
        return this.code;
      }
      case 'croatian': {
        this.code = 'flag flag-' + LangContryCode.croatian;
        return this.code;
      }
      case 'khmer': {
        this.code = 'flag flag-' + LangContryCode.khmer;
        return this.code;
      }
      case 'isländisch': {
        this.code = 'flag flag-' + LangContryCode.icelandic;
        return this.code;
      }
      case 'esperanto': {
        this.code = 'flag flag-' + LangContryCode.esperant;
        return this.code;
      }
      case 'armenian': {
        this.code = 'flag flag-' + LangContryCode.armenian;
        return this.code;
      }

      case 'ukrainian': {
        this.code = 'flag flag-' + LangContryCode.ukrainian;
        return this.code;
      }
    }
    return this.code;
  }
}
